import React from 'react';
import { connect } from 'react-redux';
import StarIcon from '../icons/star';
import {toggleFavorite} from '../actions/race';

class LeaderTable extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {
    selectedTab: 'leader'
  };

  toggleFavorite(leader, fav) {
    this.props.toggleFavorite(leader, fav);
  }

  navigateToRunner(runner) {
    this.props.history.push(`/race/${this.props.raceDetail.race_id}/${this.props.eventId}/${runner.$KEY}`);
  }

  render() {

    const {leaders} = this.props;

    if (!leaders) return null;

    return (
      <table id="table-leaders" width="100%" border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th width="47">Favorite</th>

            <th width="41">Place</th>

            <th width="50">Bib</th>

            <th width="209">Name</th>

            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {leaders.map((leader, idx) => (
          <tr className="highlited" key={idx} onClick={this.navigateToRunner.bind(this, leader)}>
            <td className="aligncenter">
              <div className="checkbox custom-checkbox">
                <input type="checkbox" className="fav2" />

                <label htmlFor="fav1">

                  {this.props.favorites && this.props.favorites.filter(x => x.$KEY === leader.$KEY).length > 0 ? (
                    <StarIcon checked style={{height: '22px', width: '22px'}} onClick={this.toggleFavorite.bind(this, leader, false)} />
                  ) : (
                    <StarIcon checked={false} style={{height: '22px', width: '22px'}} onClick={this.toggleFavorite.bind(this, leader, true)} />
                  )}
                </label>
              </div>
            </td>

            <td className="aligncenter athleterow">{idx+1}</td>

            <td className="athleterow">{leader.$KEY}</td>

            <td className="athleterow">{leader.$TEAM_NAME || `${leader.$FIRST_NAME} ${leader.$LAST_NAME}`}</td>

            <td className="athleterow">{leader.$FINALTM}</td>
          </tr>
          ))}
        </tbody>
      </table>
  );
  }
}

function mapStateToProps(state) {
  return {
    favorites: state.rr360.favorites,
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId
  };
}


export default connect(mapStateToProps, {toggleFavorite})(LeaderTable);



// WEBPACK FOOTER //
// ./src/components/LeaderTable.js